app.filter('wsp', () => {
  return item => {
    const isOfficial = item.config.is_official_wsp;
    const visualName: string = isOfficial
      ? '✔  ' + item.visual_name + ' (' + item.username + ')'
      : item.visual_name + ' (' + item.username + ')';
    return visualName;
  }
});
